import axios from "axios"
import { fetchUserDetails } from "../../../MFEs/Monetization-Sdk/src/fetchStore"
import { getToken } from "../../../helpers"

let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl
let siteUrl = window?.app_data?.site?.siteInternalName
let updateEndPoint = `${apiBaseUrl}/identity/user?site=${siteUrl}`

export const getUserDetails = async () => {
    let token = await getToken(token => {return token})
            let { userId } = await fetchUserDetails()
            if(userId){

              let res = await axios.get(`${updateEndPoint}`,{
                headers: {
                  authorization : token,
                  'x-api-key': window?.xApiKey 
                }
              })
              return res.data

            }else{
              return new Error ("userID not there ")
            }
  }